export default __webpack_public_path__ + "static/media/lock-open-variant-outline.9150ad21.svg";